import renderChoices from './renderChoices.js';
import renderInput from './renderInput.js';
import renderHeader from './renderHeader.js';

export default {
    renderChoices: renderChoices,
    renderInput: renderInput,
    renderHeader: renderHeader
}